export default __webpack_public_path__ + "abe2cf410c009e85c48e42811cf80f9f.png";